// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"506":"8acd58fb","913":"504c0dd5"}[chunkId] + ".chunk.css");